<template>
  <section class="view-container clearfix">
    <div class="notice-container clearfix">
      <div class="warning-container" v-if="error">
        <div>
          <i class="empty-icon">
            <img src="../assets/img/pic_wangluoweilianjie@2x.png"/>
          </i>
          <p>{{errorDesc}}</p>
          <button @click="$emit('retry')">重试</button>
        </div>
      </div>
      <div class="empty-container" v-else-if="empty">
        <div>
          <i class="empty-icon">
            <img src="../assets/img/pic_tongyongweikong@2x.png"/>
          </i>
          <div>{{emptyDesc}}</div>
        </div>
      </div>
      <div class="permission-container" v-else-if="noPermission">
        <div>
          <i class="permission-icon">
            <img src="../assets/img/pic_tongyongweikong@2x.png"/>
          </i>
          <div>{{permissingDesc}}</div>
        </div>
      </div>
      <div class="loading-container" v-else-if="loading">
        <div>
          <i class="loading-icon"></i>
          <div>{{loadingDesc}}</div>
        </div>
      </div>
      <template v-else>
        <slot></slot>
      </template>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    loadingDesc: {
      type: String,
      default: '加载中。。。'
    },
    error: {
      type: Boolean,
      default: false
    },
    errorDesc: {
      type: String,
      default: '网络未连接'
    },
    empty: {
      type: Boolean,
      default: false
    },
    emptyDesc: {
      type: String,
      default: '暂无内容'
    },
    noPermission: {
      type: Boolean,
      default: false
    },
    permissingDesc: {
      type: String,
      default: '无权限查看内容，如未登录请登录，如已登录请点击右上角退出后使用供应商账号登录'
    }
  }
}
</script>

<style lang="scss" scoped>
.view-container {
  position: relative;
  width: 100%;
  height: 100%;
  // overflow: hidden;
  .loading-container {
    text-align: center;
    font-size: 12px;
    height: 100%;
    min-height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    .loading-icon {
      display: inline-block;
      background: url(../assets/img/loading.gif) no-repeat;
      background-size: 100%;
      width: 50px;
      height: 50px;
      margin-bottom: 5px;
    }
  }
  .empty-container, .permission-container {
    min-height: 230px;
    padding-top: 0;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .warning-container {
    min-height: 230px;
    padding-bottom: 20px;
    padding-top: 0;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #666666;
    font-weight: 400;
    button {
      font-size: 16px;
      color: #F10180;
      text-align: justify;
      font-weight: 400;
      border: 1px solid #F10180;
      border-radius: 3px;
      background: #fff;
      width: 185px;
      height: 44px;
      text-align: center;
      margin-top: 20px;
      outline: none;
      cursor: pointer;
    }
  }
}

</style>
